<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <div
          class="d-flex justify-content-between align-items-md-center align-items-start flex-md-row flex-column mb-2"
        >
          <piaf-breadcrumb :heading="$t('menu.list')" />
        </div>

        <div class="separator mb-5" />
      </b-colxx>
    </b-row>

    <div class="main-custom-tabs">
      <template v-if="isLoading">
        <div class="loading"></div>
      </template>

      <b-tabs v-else v-model="tabIndex" card>
        <template v-for="(status, index) in statusList">
          <b-tab v-if="callback.filter((item) => item.viewed === status).length > 0" :key="index">
            <template #title>
              <span class="text-uppercase">{{ $t(`general.viewed.${status}`) }}</span>
            </template>

            <template>
              <data-list-item :callback="callback.filter((item) => item.viewed === status)" @update="fetchCallback" />
              <b-row v-if="numberOfPages > 0">
                <b-colxx xxs="12">
                  <b-pagination-nav
                    size="sm"
                    :number-of-pages="numberOfPages"
                    :link-gen="linkGen"
                    v-model="page"
                    :per-page="perPage"
                    align="center"
                  >
                    <template v-slot:next-text>
                      <i class="simple-icon-arrow-right" />
                    </template>
                    <template v-slot:prev-text>
                      <i class="simple-icon-arrow-left" />
                    </template>
                    <template v-slot:first-text>
                      <i class="simple-icon-control-start" />
                    </template>
                    <template v-slot:last-text>
                      <i class="simple-icon-control-end" />
                    </template>
                  </b-pagination-nav>
                </b-colxx>
              </b-row>
            </template>
          </b-tab>
        </template>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import DataListItem from '@/components/Pages/Callback/DataList.vue'

export default {
  components: { DataListItem },
  data() {
    return {
      tabIndex: 0,
      statusList: ['no', 'yes'],
      page: this.$route.query.page || 1,
      perPage: 10,
      numberOfPages: 1,
      apiBase: '/api/dashboard/callback/list'
    }
  },
  computed: {
    apiUrl() {
      return `${this.apiBase}?page=${this.page}`
    },
    callback() {
      return this.$store.getters['callback/callback']
    },
    isLoading() {
      return this.$store.getters['callback/isLoading']
    }
  },
  mounted() {
    this.fetchCallback()
  },
  methods: {
    linkGen(pageNum) {
      return { query: { page: pageNum } }
    },
    fetchCallback() {
      this.$store.dispatch('callback/fetchCallback', { vm: this })
    }
  },
  watch: {
    apiUrl() {
      this.fetchCallback()
    }
  }
}
</script>
